import React, { useContext } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { FormControl, FormHelperText } from '@material-ui/core';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { enGB as localeen, nb as localeno } from 'date-fns/locale';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

const mapLocale = (lang: string) => {
    if (!lang) {
        return localeno;
    }
    switch (lang) {
        case 'en':
            return localeen;
        default:
            return localeno;
    }
};

export const FormDatePicker: React.FC<IFormFieldProps<Date | null>> = (
    props,
) => {
    const {
        name,
        title,
        validators,
        disabled,
        value: _value,
        helperText: _helperText,
        ...rest
    } = props;

    const { handleChange, getHelperText, hasError, formValue } =
        useFormField<Date | null>(props);

    const context = useContext(FormContext);

    let dateValue = formValue;
    if (dateValue === undefined) {
        dateValue = null;
    }

    return (
        <MuiPickersUtilsProvider
            utils={DateFnsUtils}
            locale={mapLocale(context.lang)}
        >
            <FormControl
                className="Form__Field"
                disabled={context.formDisabled || disabled}
            >
                <KeyboardDatePicker
                    {...rest}
                    id={name}
                    name={name}
                    label={title}
                    value={dateValue}
                    onChange={handleChange(name, validators)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    format="yyyy-MM-dd"
                    error={hasError()}
                    disabled={context.formDisabled || disabled}
                    InputProps={{
                        className: 'Form__DatePicker',
                    }}
                />
                <FormHelperText>{getHelperText()}</FormHelperText>
            </FormControl>
        </MuiPickersUtilsProvider>
    );
};
